import type { ButtonGroupOption } from '/react4xp/components/react-hook-form/ButtonGroup';
import type { Phrases } from '../Phrases.d';

import React, { useMemo } from 'react';
// import { ButtonGroup } from '../../../../components/react-hook-form/ButtonGroup';
import { ButtonRadioGroup } from '/react4xp/components/react-hook-form/buttonRadioGroup/ButtonRadioGroup';
import {
	type SubstanceForm,
	SUBSTANCE_FORM,
} from '../constants';
import {
	COMMON_FIELD_NAME,
	PILL_SHAPE,
} from '../constants';
import { PILL_SHAPE_ICONS } from '../Icons';


export const PillShapeButtonGroup = ({
	phrases,
	...otherProps
}: {
	phrases: Phrases;
}): React.JSX.Element => {

	const PILL_SHAPE_OPTIONS: ButtonGroupOption[] = useMemo(() => [{
		icon: PILL_SHAPE_ICONS[PILL_SHAPE.CIRCLE],
		label: phrases['notificationForm.common.pillShapeField.value.circle'],
		value: PILL_SHAPE.CIRCLE,
	},{
		// icon: faRoundedRectangle,
		label: phrases['notificationForm.common.pillShapeField.value.roundedRectangle'],
		value: PILL_SHAPE.ROUNDED_RECTANGLE,
	},{
		icon: PILL_SHAPE_ICONS[PILL_SHAPE.SQUARE],
		label: phrases['notificationForm.common.pillShapeField.value.square'],
		value: PILL_SHAPE.SQUARE,
	// },{
	// 	icon: faRectangleWide,
	// 	label: 'Rektangel',
	// 	value: 'rectangle',
	},{
		icon: PILL_SHAPE_ICONS[PILL_SHAPE.DIAMOND],
		label: phrases['notificationForm.common.pillShapeField.value.diamond'],
		value: PILL_SHAPE.DIAMOND,
	},{
		icon: PILL_SHAPE_ICONS[PILL_SHAPE.TRIANGLE],
		label: phrases['notificationForm.common.pillShapeField.value.triangle'],
		value: PILL_SHAPE.TRIANGLE,
	// },{
	// 	// icon: faPentagon,
	// 	label: 'Femkant',
	// 	value: 'pentagon',
	// },{
	// 	icon: faHexagon,
	// 	label: 'Seks eller flere kanter',
	// 	value: 'hexagon',
	},{
		label: phrases['notificationForm.common.pillShapeField.value.other'],
		value: PILL_SHAPE.OTHER,
	// },{
	// 	label: 'Vet ikke',
	// 	value: 'unknown',
	}], [phrases]);

	return (
		<ButtonRadioGroup
			{...otherProps}
			className='z-0'
			description={phrases['notificationForm.term.chooseOne']}
			name={COMMON_FIELD_NAME.PILL_SHAPE}
			options={PILL_SHAPE_OPTIONS}
			showIf={({ watch }) => (watch({ name: COMMON_FIELD_NAME.SUBSTANCE_FORM }) as SubstanceForm)?.includes(SUBSTANCE_FORM.PILL)}
		/>
	);
};
